<template>
  <header>
    <!--<div class="hello">
      <h1>{{ msg }}</h1>
      test header
    </div>-->
    <div id="HeaderBar"></div>
    <div class="ContentAligher">
      <div id="LogoMenuWrapper">
        <div id="LogoWrapper"><router-link to="/" class="header-link"><img src="./../assets/img/dan-advance-logo.svg" /></router-link></div><!--
        --><div id="MenuWrapper"><nav>
          <ul>
            <li><router-link to="/" class="header-link"><span class="menu-item-link-txt">HOME</span></router-link></li>
            <li><router-link to="/mca-market" class="header-link"><span class="menu-item-link-txt">MCA MARKET</span></router-link></li>
            <li><router-link to="/about" class="header-link"><span class="menu-item-link-txt">ABOUT</span></router-link></li>
            <li><router-link to="/contact" class="header-link"><span class="menu-item-link-txt">CONTACT US</span></router-link></li>
          </ul>
        </nav></div><!--
        --><div id="QuickContactWrapper">
          <div class="callto"><a href="tel:877-227-4060"><img src="data:image/png;base64,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"> <span>Call Us<strong>877-227-4060</strong></span></a></div>
        </div><!--
      --><div id="Menu-Icon" class="" ><span class="hamburger__icon"></span></div>
      </div>
    </div>



<div id="myNav" class="overlay">
  <div id="Menu-Icon-Close"><span class="hamburger__icon"></span></div>
  <div class="bg_box"></div>
  <!-- Overlay content -->
  <div class="overlay-content">
    <router-link to="/" class="header-link" data-aos="fade-up" data-aos-offset="0" data-aos-delay="0">Home</router-link>
    <router-link to="/mca-market" class="header-link" data-aos="fade-up" data-aos-offset="0" data-aos-delay="50">MCA MArket</router-link>
    <router-link to="/about" class="header-link" data-aos="fade-up" data-aos-offset="0" data-aos-delay="100">About</router-link>
    <router-link to="/contact" class="header-link"  data-aos="fade-up" data-aos-offset="0" data-aos-delay="150">Contact</router-link>
  </div>
</div>

  </header>
</template>
<script>
import * as $ from 'jquery'

export default {
  name: 'Header',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
   mounted() {
        var $MenuOpen = false;
        $('#Menu-Icon').click(function(event) {
          if($MenuOpen == false)
          {
            $("#myNav").height("100%");
            $(this).addClass('active');
            $MenuOpen = true;
            //setTimeout(function(){ AOS.init(); }, 300);
          }
        });

        $('#Menu-Icon-Close, .overlay-content a').click(function(event) {
            $("#myNav").height("0%");
            $(this).removeClass('active');
            $MenuOpen = false;
            $('.overlay-content a').attr( "class", '' );
            $('.overlay-content span p').attr( "class", '' );
            $(document).trigger("scroll");
        });
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Header.vue